
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"3.5","cy":"2","r":"1.5"}}),_c('circle',{attrs:{"cx":"8.5","cy":"2","r":"1.5"}}),_c('circle',{attrs:{"cx":"3.5","cy":"6","r":"1.5"}}),_c('circle',{attrs:{"cx":"8.5","cy":"6","r":"1.5"}}),_c('circle',{attrs:{"cx":"3.5","cy":"10","r":"1.5"}}),_c('circle',{attrs:{"cx":"8.5","cy":"10","r":"1.5"}}),_c('circle',{attrs:{"cx":"3.5","cy":"14","r":"1.5"}}),_c('circle',{attrs:{"cx":"8.5","cy":"14","r":"1.5"}})])
          )
        }
      }
    